import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import * as diaryActions from '../actions/diary-actions';
import { DiaryEvent } from '../models/diary-event';
import { DiaryEventsHttpService } from '../services/diary-events-http-service';

@Injectable()
export class DiaryEffects {

  constructor(
    private actions$: Actions,
    private diaryEventsHttpService: DiaryEventsHttpService
  ) { }


  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<diaryActions.Load>(diaryActions.LOAD),
    mergeMap((action) => {
      return this.diaryEventsHttpService.getDiaryEvents(action.context, action.startDate, action.endDate, action.widgetId).pipe(
        map((diaryEvents: DiaryEvent[]) => new diaryActions.LoadComplete(diaryEvents, action.widgetId.toString())),
        catchError(err => of(new diaryActions.LoadError(err, action.widgetId.toString())))
      );
    })
  ));

  loadUndated$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<diaryActions.Load>(diaryActions.LOAD_UNDATED_EVENTS),
    mergeMap((action) => {
      return this.diaryEventsHttpService.getUndatedDiaryEvents(action.context).pipe(
        map((diaryEvents: DiaryEvent[]) => new diaryActions.LoadComplete(diaryEvents, action.widgetId.toString())),
        catchError(err => of(new diaryActions.LoadError(err, action.widgetId.toString())))
      );
    })
  ));
}
